<template>
  <div class="c-group g-container">
    <Breadcrumb style="margin-bottom: 12px">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 设置计划组 </BreadcrumbItem>
    </Breadcrumb>

    <moduler :name="item.href" v-for="item in subModules" :key="item.id" :title="item.name">
      <!-- 基础信息 -->
      <div v-if="item.href === 'group_creat'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">计划计划名称</span>
          </Col>
          <Col span="12"><Input v-model="campaign.name" placeholder=""></Input></Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">推广目标</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="campaign.type" type="button">
              <Radio :label="2" :disabled="editState">应用下载</Radio>
              <Radio :label="5" :disabled="editState">销售线索收集</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放场景</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="campaign.bid_type" type="button">
              <Radio :label="0" disabled>常规投放</Radio>
              <Radio :label="1" disabled>最大转化投放</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <Poptip
              trigger="hover"
              placement="top-start"
              width="410"
              word-wrap
              content="计划的推广预算是您预期的该计划一天可消耗的最高预算，当该计划日消耗达到您所设置的预算后，将暂停投放，并停止收费，系统后台会提示预算不足，计划组的日预算最低500元。"
            >
              <Icon type="md-help-circle" size="18" color="#e3e3e3" />
            </Poptip>
            <span class="item-field row-item-must">计划预算</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="campaign.budget_mode" type="button" @on-change="chengeBudgetMode">
              <Radio label="BUDGET_MODE_INFINITE" :disabled="campaign.bid_type === 1">不限</Radio>
              <Radio label="BUDGET_MODE_DAY">指定预算</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row v-if="campaign.budget_mode === 'BUDGET_MODE_DAY'" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">日预算</span>
          </Col>
          <Col span="12">
            <Input
              v-model="campaign.day_budget"
              placeholder="请输入500-100,000,000整数"
              style="width: 352px"
              @on-blur="inputTrim('day_budget', campaign.day_budget, campaign, false)"
            >
              <span slot="append" style="padding: 0 6px"> 元 </span>
            </Input>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放方式</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="campaign.deliveryMethod" type="button">
              <Radio :label="1" disabled>手动投放</Radio>
              <Radio :label="2" disabled>智能操盘</Radio>
              <Radio :label="3" disabled>全自动投放</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <Row v-if="campaign.deliveryMethod === 2" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">自动调控</span>
          </Col>
          <Col span="12">
            <i-switch v-model="campaign.auto_adjust" disabled :true-value="1" :false-value="0"></i-switch>
          </Col>
        </Row>

        <Row v-if="campaign.type === 2" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">批量建立</span>
          </Col>
          <Col span="12">
            <i-switch v-model="batch" :disabled="editState" @on-change="changeBatch" />
          </Col>
        </Row>
        <Row v-if="batch" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <Poptip trigger="hover" placement="top-start" width="410" word-wrap content="始末数字最多相差10">
              <Icon type="md-help-circle" size="18" color="#e3e3e3" />
            </Poptip>
            <span class="item-field">数量</span>
          </Col>
          <Col span="12">
            <Input v-model="campaign.bitch_add_begin" placeholder="起始数" style="width: 60px"></Input>
            <span>&nbsp; —— &nbsp;</span>
            <Input v-model="campaign.bitch_add_end" placeholder="结束数" style="width: 60px"></Input>
          </Col>
        </Row>
      </div>
    </moduler>

    <result v-model="resultModel" :data="resultData" :show="resultShow" next="kuaishouplan" @on-retry="retry" />

    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="cannelError"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button type="primary" v-if="editState" :loading="saving" @click.stop="submit(0)">
            <span v-if="!saving">保存并关闭</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="submit(1)" disabled>
            <span v-if="!loading">保存并新建计划</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submitToNext">
            <span v-if="!loading">保存并下一步</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import mixin from './mixin'
import Moduler from '@/components/moduler.vue'
import ErrorPop from '@/components/error-pop.vue'
import Result from '@/components/convert/result-group.vue'
import { createCampaign, getCampaign, uploadCampaign } from '@/api/kuaishou.model'
import { isArray } from '@/common/js/utils'

export default {
  name: 'group',
  mixins: [mixin],
  components: { Moduler, ErrorPop, Result },
  computed: {
    ...mapGetters('Kuaishou', ['subModules']),
    editState() {
      return this.$router.currentRoute.query.t === 'edit'
    }
  },
  data() {
    return {
      loading: null,
      saving: null,
      batch: null, // 是否批量
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值
      campaign: {
        id: this.$router.currentRoute.query.id,
        name: '',
        type: 2,
        deliveryMethod: 1, // 投放方式
        budget_mode: 'BUDGET_MODE_INFINITE',
        day_budget: '',
        bitch_add_begin: '',
        bitch_add_end: '',
        bid_type: 0,
        auto_adjust: 0,
        auto_build: 0,
        auto_manage: 0
      },
      // 结果弹窗
      resultModel: null,
      resultShow: null,
      resultData: []
    }
  },
  methods: {
    getData() {
      this.$Spin.show()
      getCampaign({
        ad_account_id: this.account,
        id: this.campaign.id
      }).then((data) => {
        this.campaign.name = data.campaign_name
        this.campaign.day_budget = data.day_budget
        this.campaign.budget_mode = data.day_budget === 0 ? 'BUDGET_MODE_INFINITE' : 'BUDGET_MODE_DAY'
        this.campaign.type = data.campaign_type
        this.campaign.campaign_id = data.campaign_id
        this.campaign.bid_type = data.bid_type
        this.campaign.auto_adjust = data.auto_adjust
        this.campaign.auto_build = data.auto_build
        this.campaign.auto_manage = data.auto_manage
        if (data.auto_manage) {
          this.campaign.deliveryMethod = 3
        }

        if (data.auto_adjust && !data.auto_manage) {
          this.campaign.deliveryMethod = 2
        }
        if (!this.editState) this.campaign.id = undefined
        // 加载完成
        this.$Spin.hide()
      })
    },
    chengeBudgetMode() {
      if (this.campaign.budget_mode === 'BUDGET_MODE_INFINITE') this.campaign.day_budget = 0
    },
    changeBatch(val) {
      this.campaign.bitch_add_begin = ''
      this.campaign.bitch_add_end = ''
    },
    valid() {
      const rules = [
        {
          name: 'campaign/name',
          require: true,
          min: 4,
          max: 50,
          desc: '计划组名称'
        },
        {
          name: 'campaign/day_budget',
          require: true,
          relyon: 'campaign/budget_mode',
          relyonvalue: 'BUDGET_MODE_DAY',
          min: 500,
          max: 100000000,
          desc: '日预算'
        },
        {
          name: 'campaign/bitch_add_begin',
          require: true,
          relyon: 'batch',
          relyvalue: true,
          min: 1,
          desc: '批量起始数'
        },
        {
          name: 'campaign/bitch_add_end',
          require: true,
          relyon: 'batch',
          relyvalue: true,
          min: 1,
          desc: '批量结尾数'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submit(next) {
      // 表单验证
      this.errRes = this.valid()
      if (
        this.campaign.budget_mode === 'BUDGET_MODE_DAY' &&
        (Number(this.campaign.day_budget) < 500 || Number(this.campaign.day_budget) > 100000000 || isNaN(Number(this.campaign.day_budget)))
      ) {
        this.errRes.push({ feild: '推广计划预算', msg: '推广计划预算请输入500-100,000,000数值！' })
        this.formErr = true
      }
      if (this.errRes.length) return // 如果错误中断

      // if (this.campaign.budget_mode === 'BUDGET_MODE_INFINITE') this.campaign.day_budget = 0

      const params = {
        ad_account_id: this.account,
        campaign_id: this.campaign.id,
        campaign_name: this.campaign.name,
        day_budget: this.campaign.day_budget
      }
      if (next) {
        this.loading = true
        uploadCampaign(params).then((data) => {
          this.loading = null
          if (data) {
            this.$router.push({
              name: 'kuaishouplan',
              params: { id: data.campaign_id }
            })
          }
        })
      } else {
        this.saving = true
        uploadCampaign(params).then((data) => {
          this.saving = null
          data && this.closePageForm()
        })
      }
    },
    submitToNext() {
      // 表单验证
      this.errRes = this.valid()
      if (this.errRes.length) return // 如果错误中断

      let params = {
        ad_account_id: this.account,
        campaign_name: this.campaign.name,
        day_budget: this.campaign.day_budget,
        type: this.campaign.type,
        auto_adjust: this.campaign.auto_adjust,
        auto_build: this.campaign.auto_build,
        auto_manage: this.campaign.auto_manage
      }
      if (this.campaign.bitch_add_begin && this.campaign.bitch_add_end) {
        params = Object.assign(params, {
          bitch_add_begin: this.campaign.bitch_add_begin,
          bitch_add_end: this.campaign.bitch_add_end
        })
      }
      if (this.campaign.req_id) {
        params = Object.assign(params, {
          req_id: this.campaign.req_id
        })
      }

      this.loading = true
      createCampaign(params).then((data) => {
        this.loading = null
        this.resultShow = false
        if (data) {
          /* eslint-disable-next-line */
          const { info, req_id } = data
          // 是否批量
          if (isArray(info) && info.length > 1) {
            this.$Message.info({
              content: '批量提交成功！显示结果中...',
              onClose: () => {
                this.resultModel = true
                this.resultData = info
                /* eslint-disable-next-line */
                this.campaign.req_id = req_id
              }
            })
          } else if (info && info.id) {
            const { msg, id, status } = info
            if (status) {
              this.$Message.error({
                closable: true,
                duration: 5,
                content: msg
              })
            } else {
              this.$Message.info({
                content: '新建成功！自动跳转中...',
                onClose: () => {
                  this.$router.push({
                    name: 'kuaishouplan',
                    params: { id }
                  })
                }
              })
            }
          }
        }
      })
    }
  },
  created() {
    if (this.$router.currentRoute.query.t !== 'edit') this.beforeHandler()
    if (this.campaign.id) this.getData()
    this.$store.commit('Kuaishou/clearModulerLinks')
  },
  mounted() {
    this.toTop()
  }
}
</script>
<style lang="scss" scoped>
.c-group-submit {
  padding: 15px;
  min-width: 1130px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 #eff1fa;

  .c-btns-submit {
    text-align: right;

    button {
      margin-left: 8px !important;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
